import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import Alert from 'components/global/Alert';
import Image from 'components/global/Image';
import Typography from 'components/global/Typography';
import { ModalContent } from 'components/global/styled/Modal.styled';

import fetchRemainingAmount from 'services/common/fetchRemainingAmount';

import { PAYMENT_METHODS } from 'utils/constants';

import * as S from './Tabs.styled';

const assets = {
	paid: 'https://storage.googleapis.com/tryoto-public/public/assets/icons/payment-success.svg',
	pending: 'https://storage.googleapis.com/tryoto-public/public/assets/icons/bank-transfer.svg'
};

const Result = () => {
	const [params] = useSearchParams();
	const { paymentResult } = useSelector((state) => state?.chargeAccount);
	const user = useSelector((state) => state?.user);
	const localization = useSelector((state) => state.layout.localization);
	const onboarding = useSelector((state) => state.instruction);
	const formMethods = useFormContext();
	const { watch } = formMethods;

	const mode = params.get('mode');
	const isPaytr = mode === 'paytrsuccess' || mode === 'paytrfail';

	useEffect(() => {
		if (isPaytr) {
			window.close();
		}

		window.dataLayer.push({
			/* eslint-disable camelcase */
			event: user?.purchasedAmount === 0 ? 'wallet_first_charge' : 'wallet_recharge',
			amount: watch('subTotal'),
			user_email: user?.email,
			user_phone_number: user?.phone,
			user_first_name: user?.firstName,
			user_last_name: user?.lastName,
			user_country: user?.localization?.label,
			user_id: user?.ID,
			language: localization?.name,
			currency: user?.localization?.currency,
			payment_method: watch('selectedPaymentMethod'),
			cohort_agg: user?.generalSettings?.cohortAgg,
			cohort_intg: user?.generalSettings?.cohortIntg,
			avgShipmentPerMonth: onboarding?.averageShipmentPerMonth || ''
			/* eslint-enable camelcase */
		});

		if (watch('isPromoCodeApplied')) {
			window.dataLayer.push({
				/* eslint-disable camelcase */
				event: 'promo_code_redemption',
				first_name: user?.firstName || '',
				last_name: user?.lastName || '',
				phone: user?.phone || '',
				email: user?.email || '',
				plan: user?.planName || '',
				country: user?.localization?.label || '',
				userID: user?.ID || '',
				promo_code: watch('promoCode')
				/* eslint-enable camelcase */
			});
		} else {
			window.dataLayer.push({
				/* eslint-disable camelcase */
				event: user?.purchasedAmount === 0 ? 'wallet_first_charge' : 'wallet_charge',
				first_name: user?.firstName || '',
				last_name: user?.lastName || '',
				phone: user?.phone || '',
				email: user?.email || '',
				plan: user?.planName || '',
				country: user?.localization?.label || '',
				userID: user?.ID || '',
				value: watch('subTotal'),
				payment_method: watch('selectedPaymentMethod'),
				currency: user?.localization?.currency,
				balance: user?.remainingAmount
				/* eslint-enable camelcase */
			});
		}
	}, []);

	useEffect(() => {
		if (mode === 'otomobile' && paymentResult?.status !== 'failed') {
			window.location.href = 'oto://chargeAccountSuccess';
		}
		if (paymentResult?.status !== 'failed') {
			fetchRemainingAmount();
		}
	}, []);

	return (
		<ModalContent>
			<S.CompletedContainer>
				<Image
					url={assets[watch('selectedPaymentMethod') === PAYMENT_METHODS.BANK_CARD ? 'pending' : 'paid']}
					alt="payment"
					width="20rem"
					height="20rem"
				/>

				{watch('isPromoCodeApplied') ? (
					<>
						<Typography variant="p1" fontWeight="500" noWrap>
							promoCodeWithCreditAddedText
						</Typography>
					</>
				) : (
					<>
						<Typography variant="p1" fontWeight="500" noWrap>
							thankYouForYourPayment
						</Typography>
						<Typography variant="p2" fontWeight="400" color="var(--content-2)" noWrap>
							{paymentResult?.description === 'bankTransferReceivedInfo'
								? 'bankTransferReceivedInfo'
								: 'paymentSuccessPageContent'}
						</Typography>
					</>
				)}

				{paymentResult?.description &&
					paymentResult?.status === 'failed' &&
					paymentResult?.description !== 'bankTransferReceivedInfo' && (
						<Typography variant="p1" fontWeight="500" noWrap>
							{paymentResult?.description}
						</Typography>
					)}

				{mode === 'paytrsuccess' && <Alert content="paytrWaitForSuccess" className="mx-5" showIcon />}
			</S.CompletedContainer>
		</ModalContent>
	);
};

export default Result;
